// samlActions
export const SSO_ACTIONS = {
  SSO: 'SSO',
  RESET_SSO: 'RESET_SSO'
};

export const isAuthenticatedUsingSSO = () => ({
  type: SSO_ACTIONS.SSO
});

export const resetSSO = () => ({
  type: SSO_ACTIONS.RESET_SSO
});
